import { render, staticRenderFns } from "./CoreFilesUpload.vue?vue&type=template&id=2320ef1e&scoped=true"
import script from "./CoreFilesUpload.vue?vue&type=script&lang=js"
export * from "./CoreFilesUpload.vue?vue&type=script&lang=js"
import style0 from "./CoreFilesUpload.vue?vue&type=style&index=0&id=2320ef1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320ef1e",
  null
  
)

export default component.exports